import { render } from "./AppDebug.vue?vue&type=template&id=07c82e98&scoped=true"
import script from "./AppDebug.vue?vue&type=script&lang=js"
export * from "./AppDebug.vue?vue&type=script&lang=js"

import "./AppDebug.vue?vue&type=style&index=0&id=07c82e98&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c82e98"]])

export default __exports__